import { Component, OnInit } from '@angular/core';
//import {InputErrorStateMatcherExample} from './input-error-state-matcher-example';


@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}